import { render, staticRenderFns } from "./DateSelectFields.vue?vue&type=template&id=85645dfc&"
import script from "./DateSelectFields.vue?vue&type=script&lang=js&"
export * from "./DateSelectFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports